import http from './ajax';

const API_URL = {
  productUrl: '/Products',
};

class ProductsApi extends http {
  // eslint-disable-next-line no-unused-vars
  getAllProduct = async (params) => {
    const url = `${API_URL.productUrl}?count=10&leaf=${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }
}

export default new ProductsApi();
